import { StateBadge } from '../../../ui/Badge';
import { Button, LinkButton } from '../../../ui/Button';
import { PageHeader } from '../../../ui/misc';
import type { ReleaseDetail } from '../types';
import type { ReleaseActions } from './useReleaseActions';
export function ReleaseHeader({ r, actions }: { r: ReleaseDetail; actions: ReleaseActions }) {
  const { base, setDialog, refresh } = actions;
  return (
    <PageHeader
      title={`Release ${r.displayId}`}
      subtitle={r.title}
      actions={
        <>
          <StateBadge state={r.state} />
          {r.viewer.canEdit && (
            <Button size="sm" variant="secondary" onClick={() => setDialog('edit')}>
              {r.state === 'failed' ? 'Prepare retry' : 'Edit candidate'}
            </Button>
          )}
          {r.viewer.canCancel && (
            <Button size="sm" variant="danger-outline" onClick={() => setDialog('cancel')}>
              Cancel release
            </Button>
          )}
          {r.viewer.canRollback && (
            <LinkButton size="sm" to={`${base}/rollbacks/new`}>
              Prepare rollback
            </LinkButton>
          )}
          {r.mergeGate && (
            <Button
              size="sm"
              variant="secondary"
              onClick={() => refresh.mutate(undefined)}
              loading={refresh.isPending}
            >
              Refresh pull requests
            </Button>
          )}
          {r.environment.requiresApproval && r.state === 'draft' && (
            <Button size="sm" onClick={() => setDialog('request')} disabled={!r.viewer.canRequestApproval}>
              {r.candidate?.binding.deliveryMethod === 'external_record'
                ? 'Submit existing deployment for review'
                : 'Request approval'}
            </Button>
          )}
          {r.mergeGate && (!r.environment.requiresApproval || r.state === 'approved') && (
            <Button size="sm" onClick={() => setDialog('proceed')} disabled={!r.viewer.canProceed}>
              {r.candidate?.binding.deliveryMethod === 'manual' ? 'Start manual deployment' : 'Proceed'}
            </Button>
          )}
        </>
      }
    />
  );
}
